import { useV2UpdateUserViewMutation, V2UserViewResource } from "@generated";

// PATCH only touches attributes; relationships are left as they are.
type UserViewWrite = Omit<V2UserViewResource, "relationships">;

const useUpdateUserViewResource = () => {
  const [updateUserView, { isLoading, isError, data, error }] =
    useV2UpdateUserViewMutation();

  const triggerUpdateUserView = async (
    userViewId: string,
    userViewData: UserViewWrite
  ) => {
    try {
      const updateResult = await updateUserView({
        id: userViewId,
        body: {
          data: userViewData as V2UserViewResource,
        },
      }).unwrap();

      return updateResult;
    } catch (updateError) {
      console.error("Update failed", updateError);
      throw updateError;
    }
  };

  // Return the trigger function and any state needed
  return { triggerUpdateUserView, isLoading, isError, data, error };
};

export default useUpdateUserViewResource;
